import { render, staticRenderFns } from "./preAdmission.vue?vue&type=template&id=45b3580e"
import script from "./preAdmission.vue?vue&type=script&lang=js"
export * from "./preAdmission.vue?vue&type=script&lang=js"
import style0 from "./preAdmission.vue?vue&type=style&index=0&id=45b3580e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports